<template>
  <div>
    <div class="otodetxgflzx">
      <div class="lantit">相似法律咨询</div>
      <div class="xgllist between wrap">
        <div class="xglitem ellipsis" v-for="item in 12" :key="item">
          最高人民法院关于审理国家赔偿案件确定精神理
        </div>
      </div>
    </div>
    <div class="lawadvlist mt30 between">
      <otodetlawadv class="advitem" v-for="item in 5" :key="item" />
    </div>
  </div>
</template>

<script>
import otodetlawadv from "../components/otodetlawadv";
export default {
  components: {
    otodetlawadv,
  },
};
</script>

<style lang="scss" scoped>
.otodetxgflzx {
  width: 100%;
  height: 100%;
  padding: 40px;
  background: #ffffff;
  box-shadow: 0px 0px 8px 0px rgba(1, 1, 1, 0.08);
  border-radius: 2px;
  .lantit {
    color: #333333;
    font-size: 22px;
  }
  .xgllist {
    align-items: flex-start;
    color: #333;
    padding-top: 10px;
    .xglitem {
      font-size: 14px;
      line-height: 14px;
      margin-top: 21px;
      width: 390px;
      color: #333333;
      cursor: pointer;
      padding-left: 15px;
      position: relative;
      &:hover {
        color: #0465ea;
        &::before {
          background-color: #0465ea;
        }
      }
      &::before {
        content: "";
        position: absolute;
        top: 50%;
        transform: translateY(-50%);
        left: 0;
        width: 4px;
        height: 4px;
        background: #b5b5b5;
        border-radius: 50%;
      }
    }
  }
}
.lawadvlist {
  .advitem {
    width: 166px;
    height: 270px;
    background: #ffffff;
  }
}
</style>